import Dashboard from './Dashboard';

export const PAGE_DASHBOARD = '/dashboard';

export default Dashboard;
